import React from 'react';
import GridSection from '../GridSection';

function EditionsSection(props) {
  return <GridSection imageRatio={2} {...props} />;
}

export default EditionsSection;



// WEBPACK FOOTER //
// ./src/site-render/src/EditionsSection/EditionsSection.js